import $ from 'jquery';
window.$ = window.jQuery = $;

import landingPage from "./components/landing-page";
import flickity from "./components/flickity";
import stickyNav from "./components/sticky-nav";
import mainMenu from "./components/main-menu";
import glightbox from "./components/glightbox";
import infiniteScroll from "./components/infinite-scroll";
import popup from "./components/popup";
import contact from "./components/contact-form";
import crossFade from "./components/cross-fade";
import swiper from "./components/swiper";

document.addEventListener("DOMContentLoaded", () => {
    landingPage();
    flickity();
    stickyNav();
    mainMenu();
    glightbox();
    infiniteScroll();
    popup();
    contact();
    crossFade();
    swiper();
});
